module.exports = __webpack_public_path__ + "img/Porte hybride.15c6057c.jpg";